import { State } from '../../types';

export function getEligibilityValidationErrors(state: State): string[] {
  const {
    legalComplianceConfirmed,
    radiantBarrierInstalled,
    skipSheathingPresent,
    sprayFoamInstallationPresent,
  } = state.order;

  const hasValidEligibilityCheck = !(
    (radiantBarrierInstalled ?? true) ||
    (skipSheathingPresent ?? true) ||
    (sprayFoamInstallationPresent ?? true)
  );

  return [
    ...(hasValidEligibilityCheck ? [] : ['Eligibility Check']),
    ...(legalComplianceConfirmed ? [] : ['Legal Information']),
  ];
}
